export const { API_ID, API_ENDPOINT, REGION, ENV } = process.env;

export const PUBLIC_ID = 'public-id';
